document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 990) return;
  
  const headerMenus = document.querySelectorAll('header-menu');
  let currentOpenMenu = null;
  let closeTimeout = null;
  
  headerMenus.forEach(menu => {
    const details = menu.querySelector('details');
    if (!details) return;
    
    // Open dropdown on mouse enter
    menu.addEventListener('mouseenter', () => {
      // Clear any pending close timeout
      clearTimeout(closeTimeout);
      
      // Immediately close any other open menu
      if (currentOpenMenu && currentOpenMenu !== details) {
        currentOpenMenu.removeAttribute('open');
        // Also close nested menus in the previous menu
        const prevNested = currentOpenMenu.querySelectorAll('details[open]');
        prevNested.forEach(nested => nested.removeAttribute('open'));
      }
      
      // Open this menu
      details.setAttribute('open', '');
      currentOpenMenu = details;
    });
    
    // Close dropdown on mouse leave
    menu.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        if (details === currentOpenMenu) {
          details.removeAttribute('open');
          // Close any nested menus
          const nestedDetails = details.querySelectorAll('details');
          nestedDetails.forEach(nested => {
            nested.removeAttribute('open');
          });
          currentOpenMenu = null;
        }
      }, 250); // Slightly longer delay for smoother experience
    });
    
    // Handle nested submenus (third level)
    const subMenuDetails = details.querySelectorAll('details');
    subMenuDetails.forEach(subDetail => {
      let subCloseTimeout;
      const parentLi = subDetail.closest('li');
      
      if (parentLi) {
        parentLi.addEventListener('mouseenter', () => {
          clearTimeout(subCloseTimeout);
          // Close other submenus at the same level
          subMenuDetails.forEach(otherSub => {
            if (otherSub !== subDetail) {
              otherSub.removeAttribute('open');
            }
          });
          subDetail.setAttribute('open', '');
        });
        
        parentLi.addEventListener('mouseleave', () => {
          subCloseTimeout = setTimeout(() => {
            subDetail.removeAttribute('open');
          }, 200);
        });
      }
      
      // Prevent clicks on nested menu summaries
      const subSummary = subDetail.querySelector('summary');
      if (subSummary) {
        subSummary.addEventListener('click', (e) => {
          if (window.innerWidth >= 990) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }
    });
    
    // Handle main summary clicks - check if it has a link
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          // Check if the summary or its child has an href
          const link = summary.querySelector('a') || (summary.hasAttribute('data-href') ? summary : null);
          
          if (link) {
            // If there's a link, allow navigation
            const href = link.getAttribute('href') || summary.getAttribute('data-href');
            if (href && href !== '#') {
              // Let the link work naturally if it's an <a> tag
              if (link.tagName === 'A') {
                // Don't prevent default - let the link work
                return;
              } else {
                // If using data-href, navigate manually
                e.preventDefault();
                window.location.href = href;
              }
            } else {
              // No valid link, just prevent the default details toggle
              e.preventDefault();
            }
          } else {
            // No link found, prevent default toggle behavior
            e.preventDefault();
          }
        }
      });
    }
  });
  
  // Close menus when clicking outside
  document.addEventListener('click', (e) => {
    if (window.innerWidth >= 990 && !e.target.closest('header-menu')) {
      clearTimeout(closeTimeout);
      if (currentOpenMenu) {
        currentOpenMenu.removeAttribute('open');
        currentOpenMenu = null;
      }
    }
  });
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth < 990) {
        headerMenus.forEach(menu => {
          const details = menu.querySelector('details');
          if (details) {
            details.removeAttribute('open');
          }
        });
        currentOpenMenu = null;
      }
    }, 250);
  });
});